<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <campus-agregar-form @success="success"></campus-agregar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <campus-agregar-form @success="success"></campus-agregar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'campus-agregar-form': require('./CampusAgregarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
